class CookieParser {

    get(name) {
        if (typeof document === "undefined" || (arguments.length && !name)) {
            return;
        }
        const cookies = document.cookie ? document.cookie.split("; ") : [];
        const jar = {};
        for (let i = 0; i < cookies.length; i++) {
            const parts = cookies[i].split("=");
            const value = parts.slice(1).join("=");

            try {
                const found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = this.read(value);
                if (name === found) {
                    break;
                }
            } catch {
                // Do nothing...
            }
        }

        return name ? jar[name] : jar;

    }

    read(value) {
        if (value[0] === "\"") {
            value = value.slice(1, -1);
        }
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    }
}

window.CookieParser = new CookieParser();
